import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default class RankingAnim {
	constructor(section) {
		this.section = section;
		this.ticker = this.section.querySelector('.ticker');
		this.wrapper = this.ticker.querySelector('.ticker-wrap');
		this.speed = 50;

		this.init();
	}

	init() {

		document.fonts.ready.then(() => {
			this.tl = gsap.timeline({
				scrollTrigger: {
					trigger: this.section,
					start: "top 80%",
					once: true,
				},
			});

			this.tl.to(this.section, {
				autoAlpha: 1,
				duration: 1.5,
				ease: 'power2.inOut',
			});

		})

		// Clone il ticker-wrap per il loop seamless
		const clone = this.wrapper.cloneNode(true);
		this.ticker.appendChild(clone);

		// Calcola la larghezza e la durata
		const tickerWidth = this.wrapper.offsetWidth;
		const initDuration = tickerWidth / this.speed;

		// Anima entrambi i ticker-wrap
		const wraps = [...this.ticker.querySelectorAll('.ticker-wrap')];

		this.animation = gsap.to(wraps, {
			force3D: true,
			duration: initDuration,
			xPercent: -100,
			ease: 'none',
			repeat: -1
		});

		// Pause su hover
		this.section.addEventListener('mouseenter', () => {
			gsap.to(this.animation, { timeScale: 0, duration: 0.3 });
		});

		this.section.addEventListener('mouseleave', () => {
			gsap.to(this.animation, { timeScale: 1, duration: 0.3 });
		});

	}
}
